<script setup>
import { useMainStore } from '@/store'
import { computed, ref, onMounted } from 'vue'
import { addLateDeliverySurcharge } from '../../utils/helper'
import Swal from 'sweetalert2'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// passed properties
const props = defineProps({
  booth: {
    type: Object,
    required: true
  }
})
// emits
const emit = defineEmits(['selected'])
// reactive properties
const price = ref(0.0)
const pricePerSquareMeter = ref(0.0)
// computed properties
const locale = computed(() => store.settings.locale)
const earlyBirdMode = computed(() => store.tmp.early_bird_mode)
const lateDelivery = computed(() => store.tmp.late_delivery)
const shoppingCart = computed(() => store.settings.shopping_cart)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const powerDescription = computed(() => {
  return (inEnglish.value) ? props.booth.power_connection_en : props.booth.power_connection
})
// methods
const selected = () => {
  if (props.booth.minimum_square_meter <= shoppingCart.value.getSquareMeter()) {
    emit('selected', props.booth)
  } else {
    Swal.fire({
      title: t('configurator.notices.titles.booth_package_selection'),
      html: t('configurator.notices.messages.minimum_square_meter').replace("[SQUARE_METER]", props.booth.minimum_square_meter),
      showCancelButton: false,
      confirmButtonText: t('configurator.buttons.ok'),
    })
  }
}
// onMounted
onMounted(() => {
  if (earlyBirdMode.value) {
    price.value = addLateDeliverySurcharge(props.booth.price, lateDelivery.value)
    pricePerSquareMeter.value = addLateDeliverySurcharge(props.booth.pricePerSquareMeter, lateDelivery.value)
  } else {
    price.value = props.booth.price
    pricePerSquareMeter.value = props.booth.pricePerSquareMeter
  }
})
</script>

<template>
  <a href="#" @click="selected">
    <div class="box-two proerty-item">
      <div class="item-thumb">
        <img v-if="booth.previewImage" :src="booth.previewImage" />
        <img v-else :src="'/images/background.jpg'" alt="default image" />
      </div>
      <div class="item-entry row">
        <div class="col-md-12" :class="{'item-entry--with-price': price > 0}">
          <h5>{{ booth.displayName }}</h5>
          <h5 v-if="price > 0" class="text-right"><small>{{ $filters.formatMoney(price) }}</small></h5>
        </div>
        <div v-if="pricePerSquareMeter > 0" class="col-md-12 text-right font-weight-400">
          (1m<sup>2</sup> = {{ $filters.formatMoney(pricePerSquareMeter) }})
        </div>
        <div class="col-md-12 font-weight-400">{{ powerDescription }}</div>
      </div>
    </div>
  </a>
</template>